<template>
  <div class="link">
    <div id="head">
      <img src="@/assets/link.png">
      <p>相关链接</p>
    </div>
    <div id="content" v-if="Links.length">
      <div v-for="item in Links">
        <img id="blue-icon" src="@/assets/blue-arrow.svg">
        <a :href="item.LinksUrl" target="_blank">{{item.LinksTitle}}</a>
      </div>
    </div>
    <div class="empty" v-else>暂无</div>
  </div>
</template>

<script>
export default {
  name: "aboutLink",
  props: {
    Links: Array
  },
};
</script>
<style lang="scss" scoped>
#head {
  display: flex;
  align-items: center;
  p {
    font-size: 24px;
    margin-left: 10px;
  }
  img {
    height: 32px;
    width: 32px;
  }
}

#content {
  #blue-icon {
    transform: rotate(225deg);
    width: 10px;
    margin: 20px 12px 0 12px;
  }
  a {
    font-size: 16px;
    color: #aaaaaa;
    &:hover {
      color: #555;
    }
  }
}
.empty {
  margin-top: 10px;
  margin-left: 45px;
  color: #aaa;
  font-size: 18px;
}
</style>

